// client/src/services/callBoardService.js
// Transfer / end calls on the receptionist / manager call board. The server
// re-checks that this user may act on the call and picks the 3CX leg itself.
import { apiClient } from './apiClient';

const messageFrom = (error, fallback) =>
  error?.response?.data?.message || fallback;

export async function transferBoardCall(callId, destination) {
  try {
    const { data } = await apiClient.post(`/call-board/${encodeURIComponent(callId)}/transfer`, { destination, timeout: 30 });
    return { success: !!data?.success, message: data?.message || `Transfer to ${destination} initiated` };
  } catch (error) {
    return { success: false, message: messageFrom(error, 'Transfer failed. Please try again.') };
  }
}

export async function endBoardCall(callId) {
  try {
    const { data } = await apiClient.post(`/call-board/${encodeURIComponent(callId)}/end`);
    return { success: !!data?.success, message: data?.message || 'Call ended' };
  } catch (error) {
    return { success: false, message: messageFrom(error, 'Could not end the call. Please try again.') };
  }
}
